/*global jQuery, magnificPopup */
(function ($, window, undefined) {

  // lightbox init

  $('.js-lightbox').magnificPopup({
    type: 'image',
    tLoading: 'Laden...',
    tClose: 'Schliessen (Esc)',
    image: {
      titleSrc: function (item) {
        var title = item.el.attr('title') || item.el.find('img').attr('title');
        var description = item.img.attr('alt');
        return ((title) ? title : '');
        // return ((title)?title:'') + ((description)?'<small>'+ description +'</small>':'');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1],
      tCounter: '%curr% von %total%',
      tPrev: 'Zurück',
      tNext: 'Vor'
    },
    mainClass: 'mfp-zoom',
    removalDelay: 500,
    callbacks: {
      beforeOpen: function() {
        // just a hack that adds mfp-anim class to markup
        this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
        this.st.mainClass = 'mfp-zoom';
      }
    }
  });

  window.addEventListener("click", function(event) {
    if (event.target.nodeName === 'IMG' && event.target.classList.contains('mfp-img')) {
      event.target.classList.toggle('mfp-img--zoomed');
    }
  });

  $('.js-lightbox-video').magnificPopup({
    type: 'iframe',
    tLoading: 'Laden...',
    tClose: 'Schliessen (Esc)',
    disableOn: 576,
    removalDelay: 500,
    preloader: false,
    fixedContentPos: false,
    mainClass: 'mfp-zoom',
    iframe: {
      patterns: {
        youtube: {
          src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0&vq=hd1080'
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%'
        }
      },
    },
    gallery: {
      enabled: false,
      navigateByImgClick: true,
      preload: [0, 1],
      tCounter: '%curr% von %total%',
      tPrev: 'Zurück',
      tNext: 'Vor'
    }
  });

  $('.js-lightbox-inline').magnificPopup({
    type: 'inline',
    preloader: false
  });

  // type in url is not parsed in typo3 9. https://forge.typo3.org/issues/87104
  // type=666 (TYPO3 Ajax type) is added
  $('.js-lightbox-ajax').magnificPopup({
    type: 'ajax',
    callbacks: {
      elementParse: function (item) {
        this.st.ajax.settings.url = item.el.data('ajaxurl');
      }
    },
    ajax: {
      settings: {
        // url: this
        // type: "GET",
        // data: {
        //   type: '666'
        // }
      }
    },
    tLoading: 'Laden...',
    tClose: 'Schliessen (Esc)',
    removalDelay: 500,
    preloader: true,
    alignTop: true,
    overflowY: 'scroll',
    mainClass: 'mfp-zoom'
  });


  $(document).on( 'click', '.js-lightbox-close', function() {
    $.magnificPopup.close();
  });


})(jQuery, window);
